
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff } from "lucide-react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { AuthFormValues } from "@/schemas/authSchema";

interface MobilePasswordFieldProps {
  mode: "signin" | "signup";
  showPassword: boolean;
  onTogglePassword: () => void;
  onForgotPassword: () => void;
  register: UseFormRegister<AuthFormValues>;
  errors: FieldErrors<AuthFormValues>;
}

export function MobilePasswordField({
  mode,
  showPassword,
  onTogglePassword,
  onForgotPassword,
  register,
  errors,
}: MobilePasswordFieldProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label htmlFor="password">Password</Label>
        {mode === "signin" && (
          <button
            type="button"
            onClick={onForgotPassword}
            className="text-sm text-primary hover:underline"
          >
            Forgot password?
          </button>
        )}
      </div>
      <div className="relative">
        <Input
          id="password"
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          className="mobile-form-input pr-12"
          autoComplete={mode === "signup" ? "new-password" : "current-password"}
          {...register("password")}
        />
        <button
          type="button"
          onClick={onTogglePassword}
          className="absolute right-3 top-1/2 -translate-y-1/2 mobile-touch-target"
        >
          {showPassword ? (
            <EyeOff className="h-5 w-5 text-muted-foreground" />
          ) : (
            <Eye className="h-5 w-5 text-muted-foreground" />
          )}
        </button>
      </div>
      {errors.password && (
        <p className="text-sm text-destructive">
          {errors.password.message}
        </p>
      )}
    </div>
  );
}
